import config from "../../config/config";
export async function sendEmailNotification(
  emailId,
  templateId,
  contentDictionary
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      EmailId: emailId,
      TemplateId: templateId,
      ContentDictionary: contentDictionary,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/Notification/sendemail",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}

export async function sendEmailNotification_v2(emailId, formId) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      emailId: emailId,
      formId: formId,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/Notification/send-email",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
